export default __webpack_public_path__ + "4e5e55f796d1f96e08b64ce0fb139ffa.jpg";